require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-glen-pham.json") })
        }
      }, "path---blog-author-glen-pham");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-glen-pham!./.cache/json/blog-author-glen-pham.json
// module id = 643
// module chunks = 231608221292675